/*
 * Farida Gupta - product card image gallery (theme/snippets/product-card.liquid).
 *
 * Deliberately independent of theme.js's <product-card> custom element (which only reacts to
 * variant swatch selection) rather than extending its private WeakMap-backed internals - this is
 * a self-contained click handler over .product-card__gallery-prev/-next, toggling which
 * .product-card__image--secondary carries "is-active" (the class the hover-swap CSS in
 * theme.css targets). Event delegation on document means one listener covers every card on the
 * page, including any added later by infinite scroll/pagination.
 *
 * Also stamps "has-gallery-swap" on the figure the first time it's used, which desktop's
 * ":hover" crossfade gate (fg-theme.css) doesn't key off but is kept for parity.
 *
 * Touch (pointer: coarse) hides .product-card__gallery-controls entirely and lets the shopper
 * swipe through .product-card__image via native horizontal scroll-snap instead (fg-theme.css),
 * so this click handler only ever fires on pointer:fine devices.
 *
 * Product videos (product-card.liquid's video-media.product-card__video, gated behind
 * settings.show_product_card_video) share this same .product-card__image--secondary/is-active
 * machinery, but a crossfaded-in video also needs an actual play()/pause() call - CSS opacity
 * alone doesn't start or stop it. It's rendered with autoplay="false" (no built-in inView
 * autoplay) precisely so playback is driven from here instead. Desktop (pointer: fine) only: the
 * crossfade only shows on :hover, so playback follows pointerover/pointerout on the figure, same
 * trigger as the CSS. Touch gets no video at all - fg-theme.css's pointer:coarse block drops
 * .product-card__video from the swipe strip entirely, so there's nothing to play there.
 */
function pauseCardVideos(figure) {
  figure.querySelectorAll('video-media.product-card__video').forEach((video) => video.pause());
}

function playActiveCardVideo(figure) {
  figure.querySelector('video-media.product-card__video.is-active')?.play();
}

document.addEventListener('click', (event) => {
  const button = event.target.closest('.product-card__gallery-prev, .product-card__gallery-next');

  if (!button) return;

  const figure = button.closest('.product-card__figure');
  const images = figure ? Array.from(figure.querySelectorAll('.product-card__image--secondary')) : [];

  if (images.length < 2) return;

  const currentIndex = images.findIndex((image) => image.classList.contains('is-active'));
  const direction = button.classList.contains('product-card__gallery-prev') ? -1 : 1;
  const nextIndex = (currentIndex + direction + images.length) % images.length;

  images[currentIndex]?.classList.remove('is-active');
  images[nextIndex].classList.add('is-active');
  figure.classList.add('has-gallery-swap');

  pauseCardVideos(figure);
  playActiveCardVideo(figure);
});

if (window.matchMedia('(pointer: fine)').matches) {
  document.addEventListener('pointerover', (event) => {
    const figure = event.target.closest('.product-card__figure');

    if (figure) playActiveCardVideo(figure);
  });

  document.addEventListener('pointerout', (event) => {
    const figure = event.target.closest('.product-card__figure');

    if (!figure || figure.contains(event.relatedTarget)) return;

    pauseCardVideos(figure);
  });
}
